(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["phone-compatibility"] && !Shopify.designMode) return;
  try {
    
      // Popup
    let popup = document.getElementById('popup')

    function openPopup(){
      popup.classList.add('open-popup')
    }

    function closePopup(){
      popup.classList.remove('open-popup')
    }


    const tabs = document.querySelectorAll(".tab");
    const lists = document.querySelectorAll(".device-list");

    tabs.forEach(tab => {
      tab.addEventListener("click", () => {
        // Remove active state from all
        tabs.forEach(t => t.classList.remove("active"));
        tab.classList.add("active");

        // Hide all lists
        lists.forEach(list => list.classList.add("hidden"));

        // Show the target one
        const target = tab.getAttribute("data-target");
        document.getElementById(target).classList.remove("hidden");
      });
    });

    const headers = document.querySelectorAll(".accordion-header");

    headers.forEach(header => {
      header.addEventListener("click", () => {
        const body = header.nextElementSibling;

        // Close other accordions (optional)
        document.querySelectorAll(".accordion-body").forEach(b => {
          if (b !== body) b.style.display = "none";
        });

        // Toggle current one
        body.style.display = (body.style.display === "block") ? "none" : "block";
      });
    });




    // Search Bar
document.addEventListener("DOMContentLoaded", function () {
  const input = document.getElementById("modelSearch");
  const resultList = document.getElementById("searchResults");

  let models = [];

  const jsonURL = "https://cdn.shopify.com/s/files/1/0944/9485/1412/files/models_corrected.json?v=1783936611";

  // Load models
  fetch(jsonURL)
    .then((res) => res.json())
    .then((data) => {
      models = data; // array of objects like { name, compatible, category }
    });

  input.addEventListener("input", () => {
    const query = input.value.toLowerCase();
    resultList.innerHTML = "";

    if (query.length === 0) {
      resultList.style.display = "none";
      return;
    }

    const filtered = models.filter((model) =>
      model.name.toLowerCase().includes(query)
    );

    if (filtered.length === 0) {
      resultList.innerHTML = "<li>No results found</li>";
      resultList.style.display = "block";
      return;
    }

    const grouped = filtered.reduce((acc, model) => {
      const category = model.category || "Other";
      if (!acc[category]) acc[category] = [];
      acc[category].push(model);
      return acc;
    }, {});

    Object.entries(grouped).forEach(([category, items]) => {
      const categoryHeader = document.createElement("li");
      categoryHeader.innerHTML = `<strong>${category}</strong>`;
      categoryHeader.style.marginTop = "10px";
      resultList.appendChild(categoryHeader);

      items.forEach((model) => {
        const li = document.createElement("li");
        li.innerHTML = `${model.name} — <strong style="color: ${model.compatible ? 'green' : 'red'}">${model.compatible ? 'Compatible' : 'Not Compatible'}</strong>`;
        resultList.appendChild(li);
      });
    });

    resultList.style.display = "block";
  });

  // ✅ Fix: This part must be INSIDE the DOMContentLoaded callback
  document.addEventListener("click", (e) => {
    if (!input.contains(e.target) && !resultList.contains(e.target)) {
      resultList.style.display = "none";
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
